// import { ReactComponent as BannerIMG } from '../../../assets/2024/BANNER.png';
import BannerIMG from '../../../assets/quantum/1x/banner.png';

export const Banner = () => {
  return (
    <>
      <section className="page-section snn-banner">
        <div>
          <img src={BannerIMG} alt="Banner" />
        </div>
      </section>
    </>
  );
};
